
export const getProducts = function (state) {
    return state.products
}

export const getBundles = function (state) {
    return state.bundles
}

export const getCurrentCartIndex = (state) => state.currentCart

export const getAllCartIndices = (state) => state.cartIndices

export const getPaymentsMode = function(state){
    return state.payments;
}

export const getCheckoutMode = function(state){
    return state.checkoutMode
}
export const getPaymentMethods = (state) => state.paymentMethods

export const getCurrentProduct = function (state) {
    return state.currentProduct
}

export const getTotalAmount = function (state) {
    return state.totalAmount
}

export const getNote = function (state) {
    return state.note
}

export const getFormatedTotalAmount = (state, getters) => {
    return parseFloat(getters.getTotalAmount)
}

export const getLoyaltyRewardSelected = (state) => !!state.loyaltyRewardId

export const getSelectedLoyaltyReward = (state) => ({
    id: state.loyaltyRewardId,
    label: state.loyaltyRewardLabel,
    type: state.loyaltyRewardType,
    value: state.loyaltyRewardValue,
    product: state.loyaltyRewardProduct,
})

export const getLoyaltyDiscount = (state, getters) => {
    if (!state.loyaltyRewardId || state.loyaltyRewardType === 'free_product') return 0
    const total = parseFloat(getters.getTotalAmount) || 0
    const discount = state.loyaltyRewardType === 'percentage'
        ? (total * state.loyaltyRewardValue) / 100
        : state.loyaltyRewardValue
    return Math.max(0, Math.min(discount, total))
}

export const getDiscount = (state) => state.discount

export const getGlobalDiscountAmount = (state, getters) => {
    const total = parseFloat(getters.getTotalAmount) || 0
    const discount = (total * (parseFloat(state.discount) || 0)) / 100
    return Math.max(0, Math.min(discount, total))
}

export const getTotalAmountWithLoyalty = (state, getters) => {
    return Math.max(0, getters.getFormatedTotalAmount - getters.getLoyaltyDiscount - getters.getGlobalDiscountAmount)
}

export const getDonateAmount = function (state) {
    return state.amountDonated
}

export const getFormatedTotalAmountData = function (state) {
    return state.reductions.data || []
}

export const allProductsFetch = function (state, getters) {
    let products = []
    Object.values(getters.getProducts).forEach(function (product) {
        products.push(product)
    })
    return products
}

export const getProductTotalPrice = function (state, getters) {
    return  (product)  => {
        return parseFloat(price)
       /* let price = productPrice(product)
        let formatter = formated.formatter()
        return formatter.format(parseFloat(price))*/
    }
}

export const getProductRemTitle = function () {
    return (product) => {
        if (product.remType === 'percent') {
            return 'Avec un(e) remise de <em> '+ product.remAmount + '%</em>'
        }else if (product.remType === 'amount') {
            return 'Avec un(e) remise de <em> '+ product.remAmount + '</em>'
        }
    }
}

export const getProductPromotionTitle = function () {
    return (product) => {
        if (product.type_promotion === 'fixed') {
            return 'Avec un(e) remise de <em> '+ product.price_promotion + ' € sur le prix du produit ' + productPriceFormated(product) +' au lieu de ' + realProductPriceFormated(product) +'</em>'
        }else if (product.type_promotion === 'percent') {
            return 'Avec un(e) remise de <em> '+ product.price_promotion + ' % sur le price du produit ' + productPriceFormated(product) +' au lieu de ' + realProductPriceFormated(product) +'</em>'
        }
    }
}

export const getSousTotal = (state, getters) => {
    let price = 0

    getters.allProductsFetch.forEach(function (product) {
        price = price + (priceWithoutRem(product) * parseFloat(product.number))
    })

    return price
}

// getReduction(state, getters){
//     let reduction = 0

//     getters.allProductsFetch.forEach(function (product) {
//         if (product.remId){
//             let price = parseFloat(priceWithoutRem(product)) * parseFloat(product.number)
//             if (product.remType === 'percent'){
//                 reduction = reduction +  ((price * parseFloat(product.remAmount)) / 100)
//             } else if (product.remType === 'amount') {
//                 reduction = reduction + parseFloat(product.remAmount)
//             }else {
//                 alert('pas de gestion pour ce type de remuneration')
//             }

//         }
//     })

//     return reduction
// },
